// Root Sagas - Modular Organization
// This file aggregates all module-level sagas

// Admin Modules
import profileSagas from 'modules/Admin/Profile/sagas'
import accountsSagas from 'modules/Admin/Accounts/sagas'
import companiesSagas from 'modules/Admin/Companies/sagas'
import employeesSagas from 'modules/Admin/Employees/sagas'
import inventorySagas from 'modules/Admin/Inventory/sagas'
import reportsSagas from 'modules/Admin/Reports/sagas'

// Public Modules
import publicSagas from 'modules/Public/sagas'

// Combine all module sagas
const rootEffects = [
  // Admin
  ...profileSagas,
  ...accountsSagas,
  ...companiesSagas,
  ...employeesSagas,
  ...inventorySagas,
  ...reportsSagas,

  // Public
  ...publicSagas,
]

console.log('ROOT:SagaEffects', rootEffects);

export default rootEffects;
